export const NAME = 'duplicate-proposal-modal';
